module.exports = __webpack_public_path__ + "img/family.4b344ca2.png";